// Module
var code = "<h1>Meeting Request</h1> <p><strong>From:</strong> {{ name }}</p> <p><strong>Phone:</strong> {{ phone }}</p> <p><strong>Email:</strong> {{ from }}</p> <p><strong>Date:</strong> {{ date }}</p> <p><strong>Meeting:</strong> {{ meeting }}</p> ";
// Exports
module.exports = code;